import React, { useCallback, useState } from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import RoutingModal from '@commonComponents/routingModal'
import SearchableDropdown from './searchableDropdown'
import { useMultipleMerchandiseItem } from '@EUForms/hooks/useMultipleMerchandiseItem'
import { CustomLoader } from '@commonComponents/formComponents/loader'
import InputField from '@commonComponents/formComponents/CustomInputField'
import { AddBtn } from '@commonComponents/AddBtn'
export const MultiSelectDropDown = React.memo(
  ({
    merchandiseId,
    dropDownData,
    dropdownType,
    invoiceId,
    label,
    searchable = false,
    dataList = [],
    isDisabled,
    tableName,
    fieldType,
    valueKey,
    boxNumber,
    translate,
    maxLength = 4,
    labelIcon,
    copyDocument,
    isRFI,
    isMerchandiseDisabled,
    markedDeleted
  }) => {
    const { addItem, updateItem, deleteItem, saveItem, isLoading } = useMultipleMerchandiseItem({
      invoiceId,
      merchandiseId,
    })
    let [selectedValue, setSelectedValue] = useState('')
    const AddItem = useCallback(
      (value) => {
        addItem(tableName, { [valueKey]: value }) //this is a hack as core data is not implementing the recommended changes
      },
      [addItem]
    )
    const updateData = useCallback(
      (id, payload) => {
        updateItem(id, tableName, payload)
      },
      [updateItem]
    )
    const deleteData = useCallback(
      (id) => {
        deleteItem(id, tableName)
      },
      [deleteItem]
    )
    const saveData = useCallback(
      (payload) => {
        saveItem(tableName, payload)
      },
      [saveItem]
    )
    // const onChangeHandler = useCallback(
    //   (E,{ target: { value, name } }) => onChange(value, name),
    //   []
    // )
    const Field = ({ isDisabled, errors }) => {
      if (fieldType === 'dropdown')
        return (
          <div style={{ width: '100%' }}>
            <DropDown
              id={`${label - merchandiseId}`}
              label={label}
              boxNumber={boxNumber}
              labelClass='text-none'
              isLabel={true}
              data={dropDownData}
              name={valueKey}
              isDisabled={isDisabled||isMerchandiseDisabled}
              clearable
              value={selectedValue}
              text={selectedValue}
              onChange={(e, { value }) => setSelectedValue(value)}
            />
          </div>
        )
      else if (fieldType === 'searchableDropdown')
        return (
          <SearchableDropdown
            style={{ width: '100%' }}
            width='3'
            boxNumber={boxNumber}
            columnClassName='dropDown-width'
            id={`${label - merchandiseId}`}
            dropdownType={dropdownType}
            isDisabled={isDisabled||isMerchandiseDisabled}
            name={valueKey}
            clearable
            label={label}
            text={selectedValue}
            selectedValue={selectedValue}
            onSelect={({ value }) => setSelectedValue(value)}
            onBlur={({ value }) => setSelectedValue(value)}
          />
        )
      else {
        return (
          <InputField
            id={`${label - merchandiseId}`}
            type='text'
            label={label}
            boxNumber={boxNumber}
            value={selectedValue}
            onChange={(e, { value }) => setSelectedValue(value)}
            name={valueKey}
            labelIcon={labelIcon}
            isDisabled={isDisabled||isMerchandiseDisabled}
          />
        )
      }
    }
    return (
      <>
        <div style={{ display: 'flex', flexGrow: 1 }}>{Field({ isDisabled })}</div>
        {isLoading && <CustomLoader />}
        <AddBtn
          text='ADD'
          size='mini'
          className='addrepeatBtn'
          disabled={!selectedValue || (valueKey === 'code' && selectedValue?.length !== 4)}
          onClick={() => {
            setSelectedValue('')
            AddItem(selectedValue)
          }}
        />
        <RoutingModal
          headerName={translate(label, { ns: ['default', 'items'] })}
          copyDocument={copyDocument}
          triggerContent={
            <span
              style={{
                top: '50%',
                position: 'relative',
                marginRight: '.8rem',
                marginLeft: '.4rem',
                fontWeight: '800',
                background: 'white',
                color: '#1765ae',
                cursor: 'pointer',
                height: '50%'
              }}
            >
              {' '}
              {dataList?.length > 0 && dataList?.length}
            </span>
          }
          valueKey={valueKey}
          limit={'10'}
          disableAddBtn={true}
          AddItem={AddItem}
          saveData={saveData}
          updateData={updateData}
          deleteData={deleteData}
          dropdownType={dropdownType}
          dataList={dataList}
          fieldType={fieldType}
          dataSource={dropDownData}
          tableName={tableName}
          isRFI={isRFI}
          isParentDisabled={isMerchandiseDisabled}
          markedDeleted={markedDeleted}
        />
      </>
    )
  }
)

MultiSelectDropDown.defaultProps = {
  translate: (value) => value,
}
